import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import {
  BaseHttpService,
  HttpResult,
} from "../../core/services/base-http.service";
import { BaseResponse } from "../../shared/models/base-response.model";
import { InviteDetailsModel } from "./exh-invite.model";
import { apiEndpoints } from "../../core/constants/api-strings";

@Injectable({ providedIn: "root" })
export class ExhInviteApiService extends BaseHttpService {
  // Base URL for farmer-related APIs
  private readonly farmerBaseUrl = environment.farmer_base_url;

  // Logged-in farmer's ID
  private farmerId = this.storage.getLoggedUserId();

  // Event code, defaults to 'KISAN25' if not set
  private eventcode = this.storage.getEventCode() || "KISAN25";

  /**
   * Retrieves the invitation details based on the provided invitation code.
   *
   * @param invitation_code - The unique code associated with the invitation.
   * @returns An observable containing the HTTP result with the base response and invite details model.
   */
  getInvitationDetails(
    invitation_code: string
  ): Observable<HttpResult<BaseResponse<InviteDetailsModel>>> {
    let serviceName = `${
      this.farmerBaseUrl +
      this.farmerId +
      apiEndpoints.farmerRegister.events +
      this.eventcode +
      apiEndpoints.farmerRegister.exhInvite +
      invitation_code
    }`;

    // Make a GET request to the constructed service URL with authentication
    return this.get<BaseResponse<InviteDetailsModel>>(serviceName, {}, true);
  }

  // Accept an invitation using the provided invitation code
  acceptInvitation(
    invitation_code: string
  ): Observable<HttpResult<BaseResponse<any>>> {
    let serviceName = `${
      this.farmerBaseUrl +
      this.farmerId +
      apiEndpoints.farmerRegister.events +
      this.eventcode +
      apiEndpoints.farmerRegister.exhInvite +
      invitation_code +
      apiEndpoints.farmerRegister.acceptInvite
    }`;
    return this.post<BaseResponse<any>>(serviceName, {}, {}, true);
  }

  // Fetch the list of pending invitations
  getPendingInviteList(): Observable<
    HttpResult<BaseResponse<InviteDetailsModel[]>>
  > {
    let serviceName = `${
      this.farmerBaseUrl +
      this.farmerId +
      apiEndpoints.farmerRegister.events +
      this.eventcode +
      apiEndpoints.farmerRegister.exhInvitePendingList
    }`;

    // Make a GET request to the constructed service URL with authentication
    return this.get<BaseResponse<InviteDetailsModel[]>>(serviceName, {}, true);
  }
}
